"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _coreDivider = _interopRequireDefault(require("@legacy-vfuk/core-divider"));

var _coreParagraph = _interopRequireDefault(require("@legacy-vfuk/core-paragraph"));

var _coreImage = _interopRequireDefault(require("@legacy-vfuk/core-image"));

var _coreLanguagePacks = require("@legacy-vfuk/core-language-packs");

var _coreBaseProps = require("@legacy-vfuk/core-base-props");

var Styled = _interopRequireWildcard(require("./styles/PartnerInfo.style"));

var _locales = _interopRequireWildcard(require("../../locales"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PartnerInfo = function PartnerInfo(_ref) {
  var partnerLogo = _ref.partnerLogo,
      footerTheme = _ref.footerTheme,
      appearance = _ref.appearance,
      dataSelectorPrefix = _ref.dataSelectorPrefix;

  var _useTranslation = (0, _reactI18next.useTranslation)(_locales.componentName),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var memoizedResources = (0, _react.useCallback)(function () {
    return (0, _coreLanguagePacks.loadResources)(i18n, _locales.componentName, _locales["default"]);
  }, [i18n, _locales.componentName, _locales["default"]]);
  memoizedResources();
  var _footerTheme$appearan = footerTheme.appearance[appearance],
      dividerAppearance = _footerTheme$appearan.dividerAppearance,
      inverseDivider = _footerTheme$appearan.inverseDivider;
  return /*#__PURE__*/_react["default"].createElement(Styled.PartnerInfoWrapper, {
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, /*#__PURE__*/_react["default"].createElement(_coreParagraph["default"], {
    inverse: true,
    noMargin: true,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'paragraph')
  }, t('Together with')), /*#__PURE__*/_react["default"].createElement(Styled.DividerWrapper, null, /*#__PURE__*/_react["default"].createElement(_coreDivider["default"], {
    orientation: "vertical",
    appearance: dividerAppearance,
    inverse: inverseDivider,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'divider')
  })), /*#__PURE__*/_react["default"].createElement(Styled.PartnerLogo, null, /*#__PURE__*/_react["default"].createElement(_coreImage["default"], {
    sm: {
      src: partnerLogo.image,
      srcSet: {
        x1: partnerLogo.image
      }
    },
    alt: partnerLogo.srText,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'logo')
  })));
};

PartnerInfo.displayName = "PartnerInfo";
var _default = PartnerInfo;
exports["default"] = _default;
//# sourceMappingURL=PartnerInfo.js.map